import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatErr } from "./api";

export function useFetch(path) {
  const [data, setData] = useState(null);
  const reload = useCallback(async () => {
    try {
      const res = await api.get(path);
      setData(res.data);
    } catch (e) {
      toast.error(formatErr(e?.response?.data?.detail));
    }
  }, [path]);
  useEffect(() => { reload(); }, [reload]);
  return [data, reload];
}

export async function act(promise, okMsg) {
  try {
    const res = await promise;
    if (okMsg) toast.success(okMsg);
    return res.data || true;
  } catch (e) {
    toast.error(formatErr(e?.response?.data?.detail));
    return null;
  }
}
